import _ from "lodash";
import { IRebusMessage } from "./rebus-messages.component";

export class Message {
    id: number;
    typ: string;
    body: string;
    headers: string;
    formattedHeaders: string;
    parsedHeaders: any;
    priority: number;
    truncatedHeaders: string;
    formattedBody: string;
    truncatedBody: string;
    format: "json" | "xml";
    constructor(message: IRebusMessage) {
        this.body = message.body;
        this.headers = message.headers;
        this.id = message.id;
        this.priority = message.priority;
        this.parsedHeaders = JSON.parse(message.headers);
        this.formatBody(message);
        this.truncatedBody = _.truncate(this.formattedBody, { length: 500 });
        this.formattedHeaders = JSON.stringify(this.parsedHeaders, null, 2);
        this.truncatedHeaders = _.truncate(this.formattedHeaders, { length: 500 });
        this.typ = this.getType(message);
    }

    private formatBody(message: IRebusMessage) {
        try {
            const parsed = JSON.parse(this.body);
            this.formattedBody = JSON.stringify(parsed, null, 2);
            this.format = "json";
            // eslint-disable-next-line sonarjs/no-ignored-exceptions
        } catch (e) {
            this.format = "xml";
            this.formattedBody = this.prettifyXml(message.body);
        }
    }

    private getType(message: IRebusMessage): string {
        const lastPartOfTypeName = (type: string) => type.substring(type.lastIndexOf(".") + 1);

        // Försök hitta någon typ från ett meddelande utifrån bästa förmåga
        const typeSelectors = [
            () => {
                const rebusType = this.parsedHeaders["rbs2-msg-type"] as string;
                if (!rebusType) {
                    return null;
                }
                // Riktiga typen finns alltid bodyn men för att hålla ned antal tecken så trimmar vi bort så mycket som möjligt

                const withoutNamespace = rebusType.substring(0, rebusType.lastIndexOf(","));

                // Trivialt försök till att förbättra output för generics
                // Namespace.RequestResponse`1[[.V1.Masterdata.QueryAktorEventRequestResponse, Sveaskog.Rask.Services.Viol3.Messages]] =>
                // RequestResponse`1[QueryAktorEventRequestResponse] för att korta ned output.
                // eslint-disable-next-line sonarjs/duplicates-in-character-class, sonarjs/super-linear-regex
                const regex = /([A-Za-z0-9]+)`1\[\[([.A-Za-z0-9]+), .*\]\]/i;
                const regexMatch = regex.exec(withoutNamespace);
                if (regexMatch?.length === 3) {
                    return `${lastPartOfTypeName(regexMatch[1])}\`1[${lastPartOfTypeName(regexMatch[2])}]`;
                } else if (withoutNamespace.indexOf("[") > 0) {
                    // Komplicerad historia med generics
                    return withoutNamespace;
                } else {
                    return lastPartOfTypeName(withoutNamespace);
                }
            },
            () => message.subject,
            () => this.parsedHeaders["asb-subject"] as string
        ];

        for (const selector of typeSelectors) {
            const res = selector();
            if (res) {
                return res;
            }
        }

        return null;
    }

    private prettifyXml(content): string {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(content, "application/xml");
        const xsltDoc = parser.parseFromString(`
<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
  <xsl:strip-space elements="*" />
  <xsl:template match="para[content-style][not(text())]">
    <xsl:value-of select="normalize-space(.)" />
  </xsl:template>
  <xsl:template match="node()|@*">
    <xsl:copy>
      <xsl:apply-templates select="node()|@*" />
    </xsl:copy>
  </xsl:template>
  <xsl:output indent="yes" />
</xsl:stylesheet>`, "application/xml");

        const xsltProcessor = new XSLTProcessor();
        xsltProcessor.importStylesheet(xsltDoc);
        const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
        return new XMLSerializer().serializeToString(resultDoc) || content;
    }
}
